import styled from 'styled-components';

import { HorizontalCenterBlock } from '../../../styled';

export const PageWrapper = styled(HorizontalCenterBlock)`
  height: 100%;
`;

export const MainContentWrapper = styled.div`
  width: 100%;
  margin-right: 16px;
  min-width: 0;
`;

export const WorkAreaWrapper = styled.div`
  height: fit-content;
`;

export const RightContentWrapper = styled.div``;

export const MainLinksWrapper = styled.div`
  margin-bottom: 16px;
`;
